module.exports = __webpack_public_path__ + "static/888Casino-1849a34a7dc4fabb0c1783ec1491a29c.png";